export default "__VITE_ASSET__CWkAbDfc__"